import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { removerAcentos } from '../../../../../utils'
import { Inline } from '../../../../../Components/CustomUi/inline'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../Components/CustomUi/loading'
import Input from '../../../../../Components/CustomUi/input'

interface PropsTabela {
  listar_comandos: any[]
  carregando_cargos: boolean
  setPagination?: React.Dispatch<React.SetStateAction<number>>
  page?: number
  setPage?: React.Dispatch<React.SetStateAction<number>>
  total: number
  excluirCargo: Function
  confirmar_exclusao: boolean
  buscarTabela: string
  abrir: Function
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  editar: Function
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
}

export const TabelaComandos: React.FC<PropsTabela> = ({
  listar_comandos,
  carregando_cargos,
  setPagination,
  page,
  setPage,
  total,
  excluirCargo,
  confirmar_exclusao,
  fake_loading,
  id_item_atual,
  nome_item_atual,
  buscarTabela,
  setBuscarTabela,
  editar,
  setConfirmar_exclusao,
  setFake_loading,
  setId_item_atual,
  setNome_item_atual,
  abrir,
}) => {
  function buscarComandos(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <>
      <Inline alignItems='center'>
        <Input placeholder='Buscar comandos' value={buscarTabela} onChange={setBuscarTabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { id: 1, valor: 'Usuário', width: 'calc(100% - 577px)' },
          { id: 2, valor: 'Descrição', width: '400px' },
          { id: 5, valor: 'Ações', width: '170px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          marginTop: -10,
          height: listar_comandos?.length < 8 ? '100%' : 'calc(100vh - 280px)',
          position: 'relative',
          overflowX: 'hidden',
        }}
      >
        <Render condition={carregando_cargos === false}>
          {(listar_comandos ?? []).filter(buscarComandos(buscarTabela)).map((item) => {
            return (
              <RowTable key={item?.cod} onDoubleClick={undefined}>
                <RowItem width={'calc(100% - 570px)'} fontSize={13}>
                  {item?.usuario_nome}
                </RowItem>
                <RowItem width={'400px'} fontSize={13}>
                  {item?.descricao}
                </RowItem>
                <RowItem width={'170px'} gap={10}>
                  <DeleteButton
                    open={confirmar_exclusao && id_item_atual === item?.cod}
                    trigger={setConfirmar_exclusao}
                    onTrigger={() => {
                      setId_item_atual(item?.cod)
                      setNome_item_atual(item?.nome)
                    }}
                    loading={fake_loading}
                    message={`o item ${item?.nome} será excluido!`}
                    deleteds={[item?.nome]}
                    onDelete={() => {
                      excluirCargo(item?.cod)
                    }}
                    disabled={fake_loading}
                  />
                  <ButtonCustom
                    onClick={editar(item?.cod)}
                    icon={<FontAwesomeIcon icon={faEdit} />}
                  >
                    Editar
                  </ButtonCustom>
                </RowItem>
              </RowTable>
            )
          })}
        </Render>

        <Render condition={carregando_cargos}>
          <Carregando
            animation
            justifyContent='center'
            legenda='Carregando comandos...'
            size={'large'}
            height={350}
          />
        </Render>
      </BodyTable>
    </>
  )
}